import useSWR from "swr";
import { useFlags } from "flagsmith/react";
import { combinedEnvelopeEnabled } from "services/prospect";
import { FeatureFlags } from "fixtures/features";
import { useAuthToken } from "hooks/useAuthToken";

const useCombinedEnvelopeStatus = (prospectId = "", proposalId = "") => {
  const authKey = useAuthToken("HYBRID")?.token ?? "";
  const proposalToken = useAuthToken("PROPOSAL")?.token;
  const flags = useFlags([FeatureFlags.CHECKOUT_COMBINED_ENVELOPE]);
  const isCombinedEnvelopeFlagEnabled =
    flags[FeatureFlags.CHECKOUT_COMBINED_ENVELOPE]?.enabled ?? false;
  const swrKey =
    isCombinedEnvelopeFlagEnabled && prospectId && proposalId
      ? [
          "Post to get Combined Envelope Enabled",
          prospectId,
          proposalId,
          !!proposalToken,
        ]
      : null;
  const { data, error, isLoading, mutate } = useSWR(swrKey, () =>
    combinedEnvelopeEnabled({
      authKey: authKey || proposalToken || "",
      prospectId,
      proposalId,
      isCustomer: !!proposalToken,
    })
  );

  return {
    combinedEnvelopeStatus: data?.status,
    error,
    isLoading,
    optimisticRefreshCombinedEnvelopeStatus: () => mutate({ status: "SENT" }),
    refreshCombinedEnvelopeStatus: mutate,
  };
};

export { useCombinedEnvelopeStatus };
